<template>
  <v-container
    fluid
    fill-height
  >
    <v-layout
      align-center
      justify-center
    >
      <v-flex lg10 offset-lg1>
        <h2 class="text-xs-center">Welcome to Galaxie Media Admin Tool</h2>
      </v-flex>
      
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data(){
    return {
      source: "/"
    }
  }
}
</script>
